module.exports = __webpack_public_path__ + "static/media/logo.629a98ad.jpg";